import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { TiposFirmaUsuario } from 'constants/index'

const TipoFirmaFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='TIPO FIRMA' htmlFor='input-tipoFirma' md={12} alignRightAt='md' />
      <Col md={12}>
        <Field name='tipoFirma'>
          {({ field }) => (
            <Form.Select {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='input-tipoFirma'>
              <option value=''>Seleccionar</option>
              {TiposFirmaUsuario.__array.map(x => (
                <option key={x.id} value={x.id}>
                  {x.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoFirmaFormGroup)
